import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Tabs, Tab} from 'material-ui/Tabs';
import Checkbox from 'material-ui/Checkbox';
import Preorders from './preorders';
import Confirmed from './confirmed';
import Completed from './completed';

const OrdersList = props => {
  const { tabValue, handleChangeTabValue  } = props;
  const tabStyle = {
    color: '#222'
  };
  const incBarStyle = {
    color: 'white',
    background: '#F44336',
    height: '3px'
  }
  return (
    <div style={{width: '100%'}}>
      <div style={{display: 'flex', marginBottom: '12px', marginLeft: '16px'}}>
        <Checkbox
          checked={true}
          style={{width: '120px'}}
          iconStyle={{fill: '#F44336'}}
          label="Машины"
        />
        <Checkbox
          checked={true}
          style={{width: '160px'}}
          iconStyle={{fill: '#F44336'}}
          label="Аксессуары"
        />
      </div>
      <Tabs
        value={tabValue}
        onChange={handleChangeTabValue}
        tabItemContainerStyle={{background: '#ddd'}}
        inkBarStyle={incBarStyle}
      >
        <Tab label="Запросы" value="preorders" style={tabStyle} >
          <Preorders />
        </Tab>
        <Tab label="Предложения - Заказы" value="orders" style={tabStyle} >
          <Confirmed />
        </Tab>
        <Tab label="Отработанные заказы" value="orders" style={tabStyle} >
          <Completed />
        </Tab>
      </Tabs>
    </div>
  );
}

class OrdersListContainer extends Component {

  constructor(props) {
    super(props);
    this.state = { tabValue: 'preorders',
    };
  }

  handleChangeTabValue = tabValue => {
    this.setState({ tabValue });
  };

  render() {
    return (
      <div style={{width: '100%'}}>
        <OrdersList {...this.props} tabValue={this.state.value} handleChangeTabValue={this.handleChangeTabValue} />
      </div>
    )
  }

}

export default connect()(OrdersListContainer);



// WEBPACK FOOTER //
// ./src/components/layout/content/orders/index.js